module.exports = __webpack_public_path__ + "img/icon_wy11.64be5ab1.png";